<template>
  <div class="sincerityPayMent">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="wrapper">
      <img src="https://m1.pxb7.com/image/my/tool/informationForSellers-pc.png" alt="">
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/breadcrumb";
export default {
  name: 'SellAgreement',
  components: {
    breadcrumb,
  },
  data() {
    return {
      breadcrumbList: [
        {name: '全部游戏'},
        {name: '我要卖号'},
        {name: '选择游戏'},
        {name: '填写信息'},
        {name: '卖家须知'},
      ],
    }
  },
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style scoped lang="less">
.sincerityPayMent {
  width: 1200px;
  .wrapper{
    background: #ffffff;
    img{
      width: 100%;
    }
  }
}

</style>
